var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeNoPaperwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 948 595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bsxg654m9a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5EAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F6F1E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r4jsrky1sb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F2F4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2D7DC",
    d: "M4.305 86.139L0 86.139 64.451 291.5 366.698 191.533 363.79 186.392 67.023 286.535z",
    transform: "translate(.5 3.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 3.5) translate(8.139)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bsxg654m9a)",
    stroke: "#FFF",
    strokeWidth: 8,
    d: "M0 0.848H397.378V268.718H0z",
    transform: "translate(369)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M195.581 -79.165L201.797 -79.165 201.797 318.213 195.581 318.213z",
    transform: "translate(369) rotate(90 198.69 119.524)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9E2F0",
    d: "M200.244 6.216H392.26800000000003V9.042H200.244zM200.244 122.632H392.26800000000003V125.458H200.244z",
    transform: "translate(369)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M196.999 0.848H204.462V265.327H196.999z",
    transform: "translate(369)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9E2F0",
    d: "M4.975 6.216H196.999V9.042H4.975zM4.975 122.632H196.999V125.458H4.975z",
    transform: "translate(369)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r4jsrky1sb)",
    stroke: "#FFF",
    strokeWidth: 4,
    d: "M23.693 40.173H328.693V242.173H23.693z",
    transform: "rotate(-17 176.193 141.173)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2D7DC",
    d: "M4.053 89.139L290.397 2.088 344.5 176.062 341.076 180.146 288.796 6.5 4.053 91.117z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 387,
    cy: 465.351,
    fill: "#DEDCDB",
    rx: 42.5,
    ry: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2A2A2A",
    stroke: "#010107",
    strokeWidth: 11,
    d: "M0 0H288.692V167.627H0z",
    transform: "translate(503 174) translate(73.485)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000105",
    d: "M128.437 167.627H160.25500000000002V182.779H128.437z",
    transform: "translate(503 174) translate(73.485)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    d: "M280.397 9.036L92.134 159.278 280.397 159.278z",
    transform: "translate(503 174) translate(73.485)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010107",
    d: "M89.043 182.4h110.606c3.347 0 6.06 2.714 6.06 6.06H82.983c0-3.346 2.714-6.06 6.06-6.06z",
    transform: "translate(503 174) translate(73.485)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6E6E6E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.027 0L75.541 30.485 90.784 45.728 19.1 66.937 0 92.217",
    transform: "translate(503 174) translate(73.485) translate(136.67 9.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.914 56.699c-1.535-3.724 4.344 1.068 17.64 14.378V99.96l15.822 9.492M44.914 59.188L12.01 38.867 13.509 30.564",
    transform: "translate(503 174) translate(73.485) translate(136.67 9.09)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(503 174) translate(0 191.716)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0D0606",
    stroke: "#4A3437",
    strokeWidth: 7,
    d: "M12.472 0H420.048V52.273H12.472z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.182,
    cy: 96.212,
    fill: "#D8D8D8",
    fillOpacity: 0.803,
    rx: 218.182,
    ry: 9.848
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A3437",
    d: "M214.5 191.731H222.5V244.731H214.5zM29.302 247.068l-7.253 35.544c-1.163 4.227-.189 5.16 2.922 2.8 3.11-2.359 9.126-15.14 18.046-38.344H29.302zM401.494 247.068l7.252 35.544c1.163 4.227.19 5.16-2.921 2.8-3.111-2.359-9.126-15.14-18.046-38.344h13.715z",
    transform: "translate(503 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3CDD0",
    d: "M277.273 230.579H369.697V240.42700000000002H277.273z",
    transform: "translate(503 174)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9F9EA0",
    d: "M247.727 220.731L323.485 220.731 323.485 230.579 247.727 230.579z",
    transform: "translate(503 174) rotate(-15 285.606 225.655)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99C7CE",
    d: "M76.515 235.125H150V240.428H76.515z",
    transform: "translate(503 174)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A4A4A5",
    d: "M164 105L164 158.621 256.205 131.81z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-82 336.996 139.739)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F706E",
    d: "M89.9 191.358l-6.399 73.53c-20.774 6.137-40.046 6.137-57.817 0-1.611-9.035-4.639-33.545-9.081-73.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2B2B2B",
    d: "M22.948 243.141L37.095 230.424 37.095 215.042 46.849 216.447 49.778 210.902"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    d: "M37.095 223.462L46.849 230.424 46.849 243.141 41.972 247.872"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A4055",
    d: "M69.3 191.358l5.103-71.557c4.507-28.473 8.276-48.316 11.31-59.53 2.853-10.552 11.686-33.543 6.254-34.613-3.227-.636-14.994 12.892-17.564 17.792-6.895 13.149-7.143 11.46-5.579 0s5.58-11.817 5.58-33.974c0-14.77-5.646-12.274-16.937 7.491C42.505 2.926 32.908-2.375 28.677 1.065c-4.23 3.44.242 22.173 13.416 56.2-14.657-11.294-24.312-16.94-28.964-16.94-6.979 0-9.192 5.962-4.596 10.638 4.596 4.677 39.672 84.924 29.908 80.633-9.763-4.29-32.584-45.96-37.865-35.771-3.52 6.793 9.1 38.637 37.865 95.533 6.777 1.666 12.466 2.5 17.067 2.5 4.6 0 9.197-.834 13.791-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A4055",
    d: "M68.081 191.283c22.043-51.175 33.064-85.182 33.064-102.023 0-16.84-7.618-13.99-22.855 8.552-6.49 10.51-9.892 18.109-10.209 22.797-.316 4.69-.316 28.247 0 70.674z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.992,
    cy: 191.283,
    fill: "#090403",
    rx: 36.648,
    ry: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(404.73 353)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3D3",
    d: "M.001 77.186c-.022 14.603 2.016 24.995 6.114 31.174 4.099 6.179 19.63 10.015 46.594 11.508 21.505-1.117 36.27-4.953 44.292-11.508 4.378-6.568 6.712-16.96 7-31.174h-104z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.001,
    cy: 77.186,
    fill: "#0E0504",
    rx: 52,
    ry: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E0504",
    d: "M18.5 79.885L28.929 98.635 34.654 95.214 32.551 84.486 41.039 77.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A4055",
    d: "M39.447 77.186l8.27-62.943C51.524 4.748 56.41 0 62.372 0c8.944 0 9.124 10.443 9.034 20.39-.06 6.632-2.177 25.563-6.352 56.796-3.437 1.357-7.428 2.035-11.972 2.035s-9.09-.678-13.636-2.035z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A4055",
    d: "M70.171 30.109c8.08-9.945 14.31-13.795 18.692-11.552 6.571 3.364 4.855 15.217-2.449 21.257-7.304 6.04-8.147 11.82-18.764 14.875"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#070506",
    d: "M67.65 54.689c4.128-1.608 6.52-2.763 7.177-3.464-2.745-2.29-5.791-8.317-5.791-11.614 0-2.199-.462 2.827-1.386 15.078z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#627181",
    strokeLinecap: "round",
    d: "M46.416 75.936L43.323 73.186"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#627181",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.802 20.907L0 18.415M3.585 16.084L.782 13.592M4.491 11.553L1.688 9.061M4.986 7.316L2.183 4.823M5.605 2.492L2.802 0",
    transform: "rotate(40 16.922 124.79)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#627181",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.802 20.907L0 18.415M3.585 16.084L.782 13.592M4.491 11.553L1.688 9.061M4.986 7.316L2.183 4.823M5.605 2.492L2.802 0",
    transform: "scale(-1 1) rotate(-51 -12.532 111.541)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#627181",
    strokeLinecap: "round",
    d: "M62.101 75.936L59.008 73.186M64.351 58.929L61.258 56.178M66.761 41.569L63.668 38.818M47.279 70.613L44.187 67.863M62.964 70.613L59.871 67.863M65.214 53.605L62.122 50.855M67.65 34.884L64.557 32.134M48.279 65.613L45.187 62.863M63.964 65.613L60.871 62.863M66.214 48.605L63.122 45.855M68.307 29.238L65.214 26.487M48.826 60.936L45.733 58.186M51.279 77.074L54.736 74.798M52.279 70.29L55.736 68.014M53.279 63.29L56.736 61.014M54.279 56.29L57.736 54.014M55.279 49.29L58.736 47.014M56.279 42.29L59.736 40.014M57.279 35.29L60.736 33.014M58.279 28.29L61.736 26.014M59.279 21.29L62.736 19.014M60.279 14.29L63.736 12.014M61.279 7.29L64.736 5.014M49.509 55.613L46.416 52.863M49.826 50.936L46.733 48.186M50.455 45.29L47.362 42.539M51.279 39.946L48.187 37.196M52.826 35.29L49.733 32.539M53.547 30.613L50.455 27.863M53.826 24.366L50.733 21.615M54.733 18.699L51.64 15.948M55.279 13.699L52.187 10.948"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253.229,
    cy: 581,
    fill: "#D8D8D8",
    fillOpacity: 0.803,
    rx: 101,
    ry: 9.848
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D2B2B",
    d: "M209.81 218.128l-58.17-71.938L100 197.83c24.157 19.591 43.527 30.734 58.112 33.43 14.584 2.696 31.817-1.682 51.698-13.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2A2A2",
    d: "M84.059 169.562l-7.754 73.274h58.166c-2.572-24.637-7.205-41.822-13.9-51.554-6.696-9.732-18.867-16.972-36.512-21.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#302E2F",
    d: "M71.078 234.75L100 228.199 91.309 257.157z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#030303",
    d: "M132.035 139.65c-2.539-13.107 2.225-24.484 14.29-34.13-4.684-11.18-2.709-31.672 5.925-61.477 3.016-9.05 4.525-15.008 4.525-17.875 0-4.302 13.058-16.623 16.337-19.115 3.28-2.492 11.526-10.586 21.513-5.293 9.986 5.293 22.064 19.523 41.047 73.891 7.739-2.448 13.478-.064 17.218 7.15 3.018 9.388 3.018 16.96 0 22.718-3.018 5.758-43.303 17.135-120.855 34.131z",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A45556",
    d: "M9.248 236.875l15.64 98.823-7.82 15.871c2.554 3.427 5.16 3.427 7.82 0s5.643-7.666 8.949-12.716v-24.824-80.692l-24.589 3.538zM34.183 239.204l25.23 90.431-6.222 15.603c2.875 2.926 5.467 2.654 7.777-.817 2.31-3.47 4.861-7.732 7.654-12.782l-2.43-23.127-7.902-75.175-24.107 5.867z",
    transform: "matrix(-1 0 0 1 457.23 8) translate(164.456 228.697)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB7761",
    d: "M9.258 0h81.44c-2.074 20.01 9.691 66.888-16.286 117.216-17.319 33.552-30.372 54.615-39.16 63.188 11 24.198 18.83 41.821 23.486 52.87-5.288 7.393-13.117 10.786-23.487 10.18l-3.424-10.18c-4.748 5.912-12.044 7.39-21.889 4.434C7.872 230.86 4.56 214.574 0 188.85v-87.938L9.258 0z",
    transform: "matrix(-1 0 0 1 457.23 8) translate(164.456 228.697)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#A75552",
    d: "M182.813 95.075c5.522-5.11 8.738-8.909 9.645-11.398 1.361-3.733.058-6.09-1.544-11.566-1.068-3.65-2.464-8.626-4.189-14.927-.97-1.404-2.006-1.755-3.106-1.053-1.65 1.053-4.47 3.1-6.378 3.1-1.908 0-5.638-2.423-7.12-5.769-.99-2.23-2.958-7.49-5.909-15.78 10.981-5.568 19.486-12.174 25.515-19.815 3.756 6.868 2.096 8.428 8.557 12.568-1.068-6.079.695-9.072 5.29-8.98 4.43 1.722 6.645 5.263 6.645 10.623.126 3.658-2.09 6.045-6.645 7.16-.784 1.072-.784 2.367 0 3.886.783 1.518 1.038 3.63.763 6.335 6.841 23.471 15.785 38.387 26.831 44.746 11.047 6.36 15.918 9.982 14.614 10.869l-62.97 4.929V95.075z",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M235.327 93.257l33.09 23.604-13.489 67.581-1.595 18.006 6.164 40.588c-20.595 1.887-37.839 2.83-51.732 2.83s-27.966-1.903-42.22-5.71l9.532-20.711-12.473-58.097-13.515 45.92.08.103c-.28 6.42-3.988 9.751-11.121 9.99l-.366.01c-20.039 2.323-40.8-9.512-54.531-15.907-13.73-6.394-23.998-18.54-23.998-20.557 0-1.345-.622-2.85-1.865-4.515l-4.537-2.983c-1.787-1.39-1.787-3.557 0-6.5 2.682-4.414 6.345-11.633 10.047-18.319 5.408-1.81 5.417 3.965 11.374 3.807 9.04-4.548 33.188 13.05 39.61 17.165 4.281 2.743 6.631 3.33 7.05 1.76l.087-.71c1.604-12.575 6.884-25.793 15.84-39.653 12.779-10.19 27.89-22.758 45.335-37.702 9.256 5.492 17.132 8.238 23.627 8.238 6.495 0 16.363-2.746 29.606-8.238z",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M268.174 117.36c19.186 12.503 30.696 27.84 34.53 46.01 5.75 27.257-3.34 64.282-9.916 70.784-6.577 6.502-10.19 8.38-13.474 8.38-1.413 0-20.377-3.696-39.743-15.492-13.113-6.297-23.603-15.291-31.47-26.982",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D9D9D",
    d: "M260.93 156.01L254.656 184.143 264.558 191.282zM208.101 201.962c9.09 12.135 17.246 21.047 24.467 26.735 10.832 8.532 27.039 15.717 27.039 13.838v-5.165c-12.997-5.694-22.628-10.694-28.892-15-6.263-4.306-13.802-11.109-22.614-20.408z",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    d: "M203.134 33.448c-1.728-5.846-1.446-8.769.848-8.769 1.48-.112 2.37.824 2.666 2.81",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272828",
    d: "M179.221 46.329c4.613-2.863 7.427-4.294 8.441-4.294 1.521 0-2.938 5.781-4.22 5.781-.443 0-1.636.267-2.376 0-.458-.165-1.073-.66-1.845-1.487z",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    d: "M177.42 39.872L175.171 39.872 174.381 30.922",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M182.588 32.62c.673-1.628 1.952-1.946 3.837-.955",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    d: "M182.588 29.059L184.507 31.103",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1A1A1A",
    d: "M181.913 23.96c.588-.38 2.092-.143 4.512.71",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    d: "M171.903 36.095c-1.5-1.475-2.656-1.043-3.47 1.298",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A15250",
    d: "M53.599 166.133c-13.092-7.663-19.993-11.771-20.704-12.325-1.066-.83-7.798-5.066-9.114-5.792-1.316-.725-7.185-5.604-9.676-6.128-1.66-.35-5.744-1.705-12.25-4.067-.255-.971.084-1.442 1.015-1.413 1.354 0 4.11.779 8.27 2.337 1.46-.624 1.825-1.212 1.095-1.764s-4.653-3.147-11.769-7.786c-.621-1.012-.621-1.518 0-1.518.933 0-.932-1.123 0-1.873.933-.75 2.163-.674 3.085 0 .614.449 4.401 2.234 11.361 5.357v-1.966l-8.464-8.202c-.342-1.727.233-2.16 1.725-1.296 1.492.864 6.694 4.685 15.608 11.464-1.477-7.642-1.208-11.464.806-11.464.898 1.56 1.858 3.979 2.881 7.255 3.618 6.98 5.427 10.691 5.427 11.132 0 .44 1.19 2.241 3.568 5.402l24.03 10.322-6.894 12.325z",
    transform: "matrix(-1 0 0 1 457.23 8)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#893A38",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.668 14.574c-2.585-2.598-3.63-6.372-3.137-11.323M10.208 6.581L0 0",
    transform: "matrix(-1 0 0 1 457.23 8) translate(3.316 128.908)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EB7761",
    d: "M6.274 11.701L0 0 16.827 0 23.377 11.701 27.752 20.449 11.158 17.201z",
    transform: "matrix(-1 0 0 1 457.23 8) translate(152.956 127.892)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A45451",
    d: "M59.119 42.563l-7.165 12.016-17.928-15.775c-3.083-2.421-5.547-3.896-7.39-4.425-2.764-.793-10.907-4.869-12.502-5.969-1.595-1.1-1.079-1.493-1.079-2.442-.672-.918-1.987-1.968-.993-3.226-1.946-1.864-2.923-3.605-2.048-4.681-2.153-1.88-5.4-5.132-4.485-5.913.61-.52 2.787.484 6.533 3.013 6.58 2.684 10.424 4.026 11.535 4.026 1.665 0 2.786-1.638 2.226-2.832s-2.24-4.717-1.12-5.614c.746-.597 2.092 1.274 4.035 5.614l7.908 10.329 22.473 15.879z",
    transform: "matrix(-1 0 0 1 457.23 8) translate(152.956 127.892)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNoPaperwork);
export default __webpack_public_path__ + "static/media/home-no-paperwork.579db12333e42103fc16bbab8973ea9f.svg";
export { ForwardRef as ReactComponent };